import React from "react";
import { Link, NavLink } from "react-router-dom";
import { Box, Typography, IconButton, Menu, MenuItem } from "@mui/material";
import Image from "mui-image";
import MenuIcon from "@mui/icons-material/Menu";
import CloseIcon from "@mui/icons-material/Close";
import logo from "../../assets/images/fcam-logo.png";
import { sidebar } from "./AuthenticatedUserLayout";

function MainLayout(props: IWrapper) {
  const { children, showHamburger } = props;
  return (
    <div className=" ">
      <Header showHamburger={showHamburger} />
      <div className="bg-white">{children}</div>
    </div>
  );
}
export function Header({ showHamburger }: { showHamburger?: boolean }) {
  return (
    <Box mb={1} sx={{ position: "sticky", top: 0, zIndex: 30 }}>
      <Box
        bgcolor="primary.main"
        px={2}
        py={1}
        display="flex"
        alignItems="center"
        justifyContent="space-between"
      >
        <Box
          bgcolor="primary.main"
          px={2}
          py={1}
          display="flex"
          alignItems="center"
        >
          <Box>
            <Image src={logo} alt="FCMBAM" height={40} width={40} />
          </Box>
          <Typography
            variant="h6"
            ml={1}
            color="white"
            fontWeight={800}
            fontSize={{ xs: 12, md: 16 }}
          >
            FCMB ASSET MANAGEMENT
          </Typography>
        </Box>
        {showHamburger && <MobileMenu sidelinks={sidebar.links} />}
      </Box>
    </Box>
  );
}
export default MainLayout;

interface IMobileMenuProps {
  sidelinks: { link: string; label: any; icon: any }[];
}
export function MobileMenu(props: IMobileMenuProps) {
  const { sidelinks } = props;
  const [anchorEl, setAnchorEl] = React.useState(null);
  const open = Boolean(anchorEl);
  const handleClick = (event: any) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };
  return (
    <Box
      sx={{
        "@media (min-width:768px)": {
          display: "none",
        },
      }}
    >
      <IconButton
        id="basic-button"
        aria-controls={open ? "basic-menu" : undefined}
        aria-haspopup="true"
        aria-expanded={open ? "true" : undefined}
        onClick={handleClick}
      >
        {!open ? (
          <MenuIcon sx={{ color: "white" }} />
        ) : (
          <CloseIcon sx={{ color: "white" }} />
        )}
      </IconButton>
      <Menu
        id="basic-menu"
        anchorEl={anchorEl}
        open={open}
        onClose={handleClose}
        MenuListProps={{
          "aria-labelledby": "basic-button",
        }}
      >
        {sidelinks?.map((link) => (
          <NavLink key={link.link} to={link.link}>
            {({ isActive }) => (
              <MenuItem
                onClick={handleClose}
                sx={{
                  gap: 1,
                  color: "#5d2684",
                  fontSize: 12,
                  bgcolor: isActive ? "rgba(93,38,132,0.1)" : "transparent",
                }}
              >
                {link.icon}
                {link.label}
              </MenuItem>
            )}
          </NavLink>
        ))}
      </Menu>
    </Box>
  );
}
